import { MagnifyingGlassIcon } from '@phosphor-icons/react';

import { Direction } from '@enums';

import { FormField } from '../Forms';

export const SearchInput = ({ name, ...props }) => {
  return (
    <FormField
      {...props}
      name={name}
      type="search"
      withoutLabel
      fullWidth
      adornmentPosition={Direction.Right}
      adornmentClassName="pl-3"
      adornment={<MagnifyingGlassIcon className="size-4 self-center text-gray-400" />}
    />
  );
};
